import { ADMIN_MEMBER_ID, ATTENDANT_MEMBER_ID } from 'configurations/Environment';

export const PROFILE = {
  admin: { name: 'Administrador', id: ADMIN_MEMBER_ID },
  agent: { name: 'Atendente', id: ATTENDANT_MEMBER_ID },
};

export const BLIP_USER = '@blip.ai';
export const BLIP_USER_TAKE_NET = '@take.net';
